import { defineStore } from 'pinia'

export default defineStore({
  id: 'system',
  persist: true,
  state: () => {
    return {
      workspace: {
        id: '',
        type: '',
        timezone: '',
        name: ''
      },
      company: {} as {
        [key: string]: any
      },
      workspaceCompany: {} as any,
      workspaceUsers: [] as { [key: string]: any }[],
      companyUsers: [] as { [key: string]: any }[],
      menuList: [],
      primaryColor: '',
      group: {} as { [key: string]: any },
      timezone: 7,
      dateFormat: 'YYYY MMM, DD',
      timeFormat: 'HH:mm:ss',
      timezoneText: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
      miniVariant: false,
      scheduleSettings: {
        maxWaitingTime: 0,
        confirmationTime: 0,
        start: 0,
        end: 0,
        startRange1: 0,
        startRange2: 0,
        endRange1: 0,
        endRange2: 0
      },
      apps: []
    }
  },
  actions: {
    clear: function () {
      this.workspace = {
        id: '',
        type: '',
        timezone: '',
        name: ''
      }
      this.company = {}
      this.workspaceCompany = {}
      this.workspaceUsers = []
      this.companyUsers = []
      this.menuList = []
      this.primaryColor = ''
      this.group = {}
      this.timezone = 7
      this.dateFormat = 'YYYY MMM, DD'
      this.timeFormat = 'HH:mm:ss'
      this.timezoneText = '(UTC+07:00) Bangkok, Hanoi, Jakarta'
      this.miniVariant = false
      this.scheduleSettings = {
        maxWaitingTime: 0,
        confirmationTime: 0,
        start: 0,
        end: 0,
        startRange1: 0,
        startRange2: 0,
        endRange1: 0,
        endRange2: 0
      }
      this.apps = []
    },
    setWorkspace: function (payload: any) {
      this.workspace = payload || {}
    },
    setMenuList: function (payload: any) {
      this.menuList = payload || []
    },
    setCompany: function (payload: any) {
      this.company = payload || {}
    },
    setWorkspaceCompany: function (payload: any) {
      Object.assign(this.workspaceCompany, payload || {})
    },
    setWorkspaceUsers: function (payload: any) {
      this.workspaceUsers = payload || []
    },
    setCompanyUsers: function (payload: any) {
      this.companyUsers = payload || []
    },
    setPrimaryColor: function (payload: any) {
      this.primaryColor = payload || ''
    },
    setGroup: function (payload: any) {
      this.group = payload || {}
    },
    setScheduleSettings: function (payload: any) {
      Object.assign(this.scheduleSettings, payload || {})
    },
    setApps: function (payload: any) {
      const apps = payload || []
      if (Array.isArray(apps)) {
        Object.assign(this.apps, apps)
      }
    }
  },
  getters: {
    getWorkspace: (state: any) => state.workspace,
    getWorkspaceId: (state: any) => state.workspace?.id || '',
    getCompanyId: (state: any) => state.company?._id || null,
    getWorkspaceTimezone: (state: any) => state.workspace.timezone || 'UTC',
    getWorkspaceType: (state: any) => state.workspace.type || 'UTC',
    getMenuList: (state: any) => state.menuList,
    getCompany: (state: any) => state.company,
    getWorkspaceUsers: (state: any) => state.company,
    getCompanyUsers: (state: any) => state.company,
    getPrimaryColor: (state: any) => state.primaryColor,
    getGroup: (state: any) => state.group,
    getScheduleSettings: (state: any) => state.scheduleSettings,
    getApps: (state: any) => state.apps
  }
})
